'use es6';

export default {
  MOST_DOWNLOADED: 'MOST_DOWNLOADED',
  RECENTLY_ADDED: 'RECENTLY_ADDED',
  PRICE_LOW_TO_HIGH: 'PRICE_LOW_TO_HIGH',
  PRICE_HIGH_TO_LOW: 'PRICE_HIGH_TO_LOW'
};